import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

//Css
import "../../../scss/registration/registration_forum.scss";

//Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

//Modal
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

//Api functions
import {
  reactivate_team_member,
  check_invite_link,
} from "../../../functions/api";

const ReactivateMember = () => {
  const navigate = useNavigate();
  const { id, token } = useParams();

  const [inviteState, setInviteState] = useState({ status: "loading" });
  const [passwordShown, setPasswordShown] = useState("");
  const [validationError, setValidationError] = useState([]);
  const [validationMessages, setValidationMessages] = useState({});
  const [registerResponse, setRegisterResponse] = useState({});
  const [showPaywordRequirements, setShowPasswordRequirements] = useState(false);
  const [terms, setTerms] = useState(false);
  const [form, setForm] = useState({ password1: "", password2: "" });

  const handleClosePasswordRequirements = () =>
    setShowPasswordRequirements(false);

  useEffect(() => {
    check_invite_link(id, token)
      .then((data) => {
        if (!data || data.success !== true || data.reactivation !== true) {
          setInviteState({ status: "invalid" });
          return;
        }
        setInviteState({ status: "ready", userInfo: data.userInfo || {} });
      })
      .catch(() => setInviteState({ status: "invalid" }));
  }, [id, token]);

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter") {
        event.preventDefault();
        submitReactivation();
      }
    };
    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, terms, inviteState]);

  const updateField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const togglePassword = (passwordField) => setPasswordShown(passwordField);

  const validate = () => {
    const errors = [];
    const messages = {};

    if (form.password1 === "") {
      errors.push("password1");
      messages.password1 = "Verplichte invoer";
    }
    if (form.password2 === "") {
      errors.push("password2");
      messages.password2 = "Verplichte invoer";
    }
    if (form.password1 !== "" && form.password2 !== "" && form.password1 !== form.password2) {
      errors.push("password1");
      errors.push("password2");
      messages.password1 = "Wachtwoord komt niet overeen";
      messages.password2 = "Wachtwoord komt niet overeen";
    } else if (form.password1 !== "") {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,}$/;
      if (!passwordRegex.test(form.password1)) {
        errors.push("password1");
        messages.password1 = "Wachtwoord niet sterk genoeg";
      }
    }
    if (!terms) {
      errors.push("terms");
    }

    setValidationError(errors);
    setValidationMessages(messages);
    return errors.length === 0;
  };

  const submitReactivation = async () => {
    if (inviteState.status !== "ready") return;
    if (!validate()) return;

    const payload = {
      form: {
        password1: form.password1,
        password2: form.password2,
        terms,
      },
    };

    const response = await reactivate_team_member(id, token, payload);
    setRegisterResponse(response || {});

    if (response && response.message === "account-reactivated") {
      sessionStorage.setItem("registrationStatus", "success");
      navigate("/finish");
    }
  };

  if (inviteState.status === "loading") {
    return (
      <h1 style={{ color: "black", fontSize: "32px", textAlign: "center", marginTop: "40px" }}>
        Uitnodiging controleren...
      </h1>
    );
  }

  if (inviteState.status === "invalid") {
    setTimeout(() => {
      window.location.href = "/";
    }, 1500);
    return (
      <h1 style={{ color: "black", fontSize: "72px", textAlign: "center" }}>
        Invalid invite
      </h1>
    );
  }

  const { userInfo = {} } = inviteState;
  const fullName = [userInfo.first_name, userInfo.infix, userInfo.last_name]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="page-wrapper">
      <div className="register-content-wrapper">
        <div className="left-section">
          <div className="left-title">
            <h1>
              <strong>
                E<span>Z</span>
              </strong>{" "}
              Inspect
            </h1>
          </div>
          <div className="left-text">
            <h2>Heractivatie account</h2>
            <p>
              Je account was eerder uitgeschakeld. Stel hieronder een nieuw
              wachtwoord in om je account weer te activeren.
            </p>
          </div>
        </div>
        <div className="right-section">
          <div className="registration-form-wrapper">
            <div className="registration-title">
              <div className="forum-step active">
                <p>Heractiveer</p>
              </div>
            </div>
            <br />
            <div className="registration-body">
              <div className="form-step-1" style={{ display: "block" }}>
                <form method="POST">
                  <div className="input-section">
                    <label className="login-lbl" htmlFor="">
                      Naam
                    </label>
                    <div className="input-color">
                      <input type="text" value={fullName} readOnly disabled />
                    </div>
                  </div>
                  <div className="input-section">
                    <label className="login-lbl" htmlFor="">
                      Email
                    </label>
                    <div className="input-color">
                      <input type="text" value={userInfo.email || ""} readOnly disabled />
                    </div>
                  </div>
                  <div className="input-section-row">
                    <div className="input-wrapper">
                      <label className="login-lbl" htmlFor="">
                        Nieuw wachtwoord{" "}
                        <i
                          onClick={() => setShowPasswordRequirements(true)}
                          className="fa-solid fa-circle-question"
                        ></i>
                      </label>
                      <div
                        className={
                          validationError.includes("password1")
                            ? "validationError"
                            : "input-color"
                        }
                      >
                        <input
                          type={passwordShown === "1" ? "text" : "password"}
                          id="password"
                          onChange={(e) => updateField("password1", e.target.value)}
                        />
                        <div
                          onClick={
                            passwordShown !== "1"
                              ? () => togglePassword("1")
                              : () => togglePassword("")
                          }
                          className="password-toggle"
                        >
                          <i
                            className={
                              passwordShown === "1"
                                ? "fa-solid fa-eye"
                                : "fa-solid fa-eye-slash"
                            }
                          ></i>
                        </div>
                      </div>
                      <p className="validationMessage" id="password1">
                        {validationMessages.password1 || ""}
                      </p>
                    </div>
                    <div className="input-wrapper">
                      <label className="login-lbl" htmlFor="">
                        Herhaal wachtwoord
                      </label>
                      <div
                        className={
                          validationError.includes("password2")
                            ? "validationError"
                            : "input-color"
                        }
                      >
                        <input
                          type={passwordShown === "2" ? "text" : "password"}
                          id="repeat-password"
                          onChange={(e) => updateField("password2", e.target.value)}
                        />
                        <div
                          onClick={
                            passwordShown !== "2"
                              ? () => togglePassword("2")
                              : () => togglePassword("")
                          }
                          className="password-toggle"
                        >
                          <i
                            className={
                              passwordShown === "2"
                                ? "fa-solid fa-eye"
                                : "fa-solid fa-eye-slash"
                            }
                          ></i>
                        </div>
                      </div>
                      <p className="validationMessage" id="password2">
                        {validationMessages.password2 || ""}
                      </p>
                    </div>
                  </div>
                  <div style={{ marginTop: "-20px" }} className="terms-wrapper">
                    <input
                      type="checkbox"
                      id="terms-btn"
                      checked={terms}
                      onChange={() => setTerms((prev) => !prev)}
                    />
                    <label
                      className={
                        validationError.includes("terms")
                          ? "validationErrorText"
                          : ""
                      }
                      htmlFor=""
                    >
                      Klik om de{" "}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className={
                          validationError.includes("terms")
                            ? "validationErrorText"
                            : ""
                        }
                        href="https://www.ezinspect.nl/wp-content/uploads/2022/04/algemene_voorwaarden_ezinspect.pdf"
                      >
                        voorwaarden
                      </a>{" "}
                      te accepteren
                    </label>
                  </div>
                  <div
                    className={
                      registerResponse.message === "password-not-equal"
                        ? "registration-error-message"
                        : "hide-error-message"
                    }
                  >
                    <div className="text-wrapper">
                      <p>De ingevoerde wachtwoorden komen niet overeen</p>
                    </div>
                  </div>
                  <div
                    className={
                      registerResponse.message === "password-not-strong-enough"
                        ? "registration-error-message"
                        : "hide-error-message"
                    }
                  >
                    <div className="text-wrapper">
                      <p>Het ingevoerde wachtwoord is niet sterk genoeg</p>
                    </div>
                  </div>
                  <div
                    className={
                      registerResponse.message === "invalid-invite" ||
                      registerResponse.message === "target-not-disabled"
                        ? "registration-error-message"
                        : "hide-error-message"
                    }
                  >
                    <div className="text-wrapper">
                      <p>Deze uitnodiging is niet meer geldig</p>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="registration-footer">
              <div id="footer-wrapper" className="footer-wrapper notLoading">
                <button
                  onClick={() => submitReactivation()}
                  className="next-step-btn"
                >
                  Heractiveer
                </button>
              </div>
            </div>

            <Modal
              show={showPaywordRequirements}
              onHide={handleClosePasswordRequirements}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Uw wachtwoord moet voldoen aan de volgende eisen:
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Minimaal 10 karakters</p>
                <p>Minimaal 1 hoofdletter</p>
                <p>Minimaal 1 kleineletter</p>
                <p>Minimaal 1 speciaal teken (@$!%*?&)</p>
                <p>Minimaal 1 cijfer</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleClosePasswordRequirements}
                >
                  Sluiten
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactivateMember;
